import { Job } from '@betterleap/client';

export interface JobsState {
  filters?: JobsFilterState;
  selectedJob?: Job;
  searchPhrase?: string;
  loading?: boolean;
  backgroundLoading?: boolean;
  searchLoading?: boolean;
}

export interface JobsFilterState {
  organizationName?: string;
  employmentType?: Job.employmentType;
  location?: string;
  locationType?: Job.locationType;
  status?: string;
  createdById?: string;
  specialty?: Array<string>;
  shift?: Array<string>;
  license?: Array<string>;
  benefits?: Array<string>;
  education?: Array<string>;
  hourlyPayInCents?: string;
  title?: string;
  fromLocation?: string;
}

export const initialJobsFilterState: JobsFilterState = {
  organizationName: '',
  location: '',
  employmentType: undefined,
  locationType: undefined,
  status: undefined,
  createdById: undefined,
  specialty: [],
  shift: [],
  license: [],
  benefits: [],
  education: [],
  hourlyPayInCents: undefined,
  title: undefined,
  fromLocation: undefined,
};

export const initialJobsState: JobsState = {
  filters: {},
  searchPhrase: '',
  loading: false,
  backgroundLoading: false,
  searchLoading: false,
};
